import styled, { css } from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';

export const RatingStarGrey = styled(Image)`
  background-color: #595959;
  min-width: 103px;
  margin-top: 4px;
  height: 17px;
  display: inline;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 14px;
    min-width: 88px;
  }
`;

export const RatingStarLightGrey = styled(Image)`
  background-color: #d8d8d8;
  width: 100%;
  height: 17px;
  display: inline;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    height: 14px;
  }
`;

export const RatingOverlay = styled.span`
  position: absolute;
  overflow: hidden;
  width: ${(props) => `calc(${props.ratings || 0}/5*104px)`};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: ${(props) => `calc(${props.ratings || 0}/5*88px)`};
  }
`;

export const RatingContainer = styled.div`
  display: flex;
  width: 103px;
  align-items: center;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 88px;
  }
`;

const styles = css`
  padding-top: 26px;
  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: ${(props) => (props.isPDPRedesignEnabled ? `32px` : `72px`)};
  }
  .pdp-redesign-tab-structure {
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    ${(props) => {
      return (
        props.isPDPRedesignEnabled &&
        `
        @media ${props.theme.mediaQuery.large}{
          margin-bottom: 64px;
        }

    `
      );
    }}
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-left: 12px;
      margin-right: 12px;
      width: calc(100% - 24px);
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
    }
    .tab-buttons {
      position: relative;
      top: 1px;
      z-index: 10;
      color: black;
      border: none;
      border-bottom: 2px solid transparent;
      background: none;
      padding: 12px 6px 12px 6px;
      font-size: 16px;
      white-space: nowrap;
      margin: 0px 52px 0px 0px;
      cursor: pointer;
      @media ${(props) => props.theme.mediaQuery.large} {
        padding: 0px 16px 12px 16px;
        margin-right: 48px;
      }
    }
    .pdp-active-tab {
      font-weight: 700;
      border-bottom: 4px solid ${(props) => props.theme.brandSpecificStyles.PDP_ACTIVE_TAB_COLOR};
    }
  }

  .tab-accordion {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }
  .tab-top-border {
    border-top: 1px solid #d8d8d8;
  }
  .tab-accordion-item {
    border-bottom: 1px solid #d8d8d8;
  }

  .tab-accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 32px 20px;
    }
  }
  .expanded {
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 16px 20px;
    }
  }

  .tab-accordion-title {
    font-weight: bold;
    color: #000;
    font-family: Nunito;
    font-size: 20px;
    line-height: 27px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 16px;
      line-height: 22px;
    }
  }

  .tab-accordion-icon {
    font-size: 24px;
    color: #777;
    transition: transform 0.3s;
    transform: rotate(90deg);
  }

  .tab-accordion-icon.rotate {
    transform: rotate(270deg);
  }

  .tab-arrow-wrapper {
    display: flex;
    gap: 48px;
  }

  .tab-expanded {
    border-bottom: none;
  }

  .tab-raing-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .tab-rating-count {
    color: #595959;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 16px;
    }
  }

  .pdp-tabs-view-description {
    ${(props) => {
      return (
        props.isPDPRedesignEnabled &&
        `
        @media ${props.theme.mediaQuery.large}{
          padding: 0;
        }

    `
      );
    }}
  }
  #size-charts {
    ${(props) => {
      return (
        props.isPDPRedesignEnabled &&
        `
        @media ${props.theme.mediaQuery.large}{
          margin-top: 0;

        }

    `
      );
    }}
  }
`;

export default styles;
